<template>
    <b-modal
        id="floating-student-modal"
        v-model="loaded"
        ref="floating-student-modal"
        size="md"
        :title="$t('internship.floating_students')"
        modal-class="apprentice-default-modal create-internship-tag"
        :ok-title="$t('common.confirm')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @show="load($event)"
        @ok="save()">
        <design-2021-internship-floating-student-modal-table-component :data-in="internshipData">
        </design-2021-internship-floating-student-modal-table-component>
    </b-modal>
</template>

<script>
// import {ords} from "../../../app";
// import moment from "moment";

export default {
    name: 'design-2021-internship-tags-delete-floating-student-modal-component',
    data() {
        return {
            tagId: '',
            loaded: false,
            internshipData: [],
        };
    },
    methods: {
        load(data, tagId) {
            if (!this.loaded) {
                this.internshipData = data;
                this.tagId = tagId;
                this.loaded = true;
            }
        },
        save(event) {
            this.$emit('delete', this.tagId);
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
